module.exports = __webpack_public_path__ + "static/media/selfpaced-training.688cf8ec.svg";